import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { Button } from '../buttons/Button';
import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import type { AiDocumentMetadataEntry } from './types';

import styles from './DocumentPreviewMetadataSection.module.scss';

export type DocumentPreviewMetadataToggleProps = {
  isOpen: boolean;
  onToggle: () => void;
};

export function DocumentPreviewMetadataToggle({
  isOpen,
  onToggle,
}: DocumentPreviewMetadataToggleProps) {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="ai-assistant-preview-meta-toggle"
      icon={<GoogleFontIcon name="info" solid={isOpen} />}
      onClick={onToggle}
      title={
        isOpen
          ? t('app.pdfDocumentPreview.hideDocumentDetails')
          : t('app.pdfDocumentPreview.documentDetails')
      }
      variant="text"
    />
  );
}

export type DocumentPreviewMetadataSectionProps = {
  entries: readonly AiDocumentMetadataEntry[];
  isOpen: boolean;
};

export function DocumentPreviewMetadataSection({
  entries,
  isOpen,
}: DocumentPreviewMetadataSectionProps) {
  if (entries.length === 0) {
    return null;
  }

  return (
    <div
      className={clsx(styles['metadata'], {
        [styles['metadata--open']]: isOpen,
      })}
    >
      <dl className={styles['metadata-list']}>
        {entries.map((entry) => (
          <div className={styles['metadata-row']} key={entry.label}>
            <dt className={styles['metadata-key']}>{entry.label}</dt>
            <dd className={styles['metadata-value']}>{entry.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
